import MessageFile from './MessageFile.component';

export default MessageFile;